import React from 'react';
import { layout, space, typography } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components';

const Button = styled.button`
  background: transparent;
  outline: 0;
  padding: 0;

  & > span {
    padding: ${themeGet('space.xs')}px;

    width: 100%;
    height: 100%;

    ${typography}

    display: flex;
    justify-content: center;
    align-items: center;
  }

  &:focus {
    background: transparent;
  }

  &:disabled {
    opacity: 0.5;
  }

  ${space}
  ${layout}
`;

function BtnGhost({ style, className, children, type, onClick, disabled, isWaiting }) {
  return (
    <Button
      {...style}
      className={className}
      type={type}
      disabled={disabled || isWaiting}
      onClick={onClick}
    >
      <span>{children}</span>
    </Button>
  );
}

export default BtnGhost;
